import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { useT } from "../lib/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Captures the referral code into sessionStorage and bounces the visitor to
// the landing page with ?ref=<code> appended. The referral attribution gets
// applied at /auth/register time when the visitor signs up.
export default function ReferralLanding() {
  const { code } = useParams();
  const nav = useNavigate();
  const t = useT();
  const [referrerName, setReferrerName] = useState(null);
  const [resolved, setResolved] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (!code) {
      nav("/", { replace: true });
      return;
    }
    const lc = code.toLowerCase();
    sessionStorage.setItem("ref_code", lc);
    axios
      .get(`${API}/public/r/${encodeURIComponent(lc)}/resolve`)
      .then((r) => {
        if (!cancelled) setReferrerName(r.data?.referrer_name || null);
      })
      .catch(() => { /* invalid code — still send them to landing */ })
      .finally(() => {
        if (cancelled) return;
        setResolved(true);
        // Redirect after a short pause so the visitor sees the welcome copy.
        setTimeout(() => nav(`/?ref=${encodeURIComponent(lc)}`, { replace: true }), 1500);
      });
    return () => { cancelled = true; };
  }, [code, nav]);

  return (
    <div className="min-h-screen bg-[#FBF9F6] flex items-center justify-center p-6" data-testid="referral-landing">
      <div className="max-w-md w-full bg-white border border-[#E5E0D8] rounded-2xl p-8 text-center">
        <p className="text-[10px] tracking-[0.3em] uppercase text-[#4A5C50]">{t("ref.eyebrow")}</p>
        {referrerName ? (
          <h1 className="serif text-3xl mt-2 text-[#184A30]" data-testid="referral-greeting">
            {t("ref.greeting", { name: referrerName })}
          </h1>
        ) : (
          <h1 className="serif text-2xl mt-2 text-[#112318]">{t("ref.loading")}</h1>
        )}
        <p className="text-sm text-[#4A5C50] mt-3">
          {resolved ? t("ref.resolved_redirect") : t("ref.resolving")}
        </p>
      </div>
    </div>
  );
}
